import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient, QueryCommand } from "@aws-sdk/lib-dynamodb";
import { fetchAuthSession } from "aws-amplify/auth";

const {
  REACT_APP_REGION,
  REACT_APP_CUSTOMER_PREMISES_TABLENAME,
} = process.env;

const queryTable = async (awsCredentials, { user_id }) => {
  const docClient = DynamoDBDocumentClient.from(
    new DynamoDBClient({
      region: REACT_APP_REGION,
      credentials: awsCredentials,
    }),
  );

  const command = new QueryCommand({
    TableName: REACT_APP_CUSTOMER_PREMISES_TABLENAME,
    KeyConditionExpression: "#user_id = :user_id",
    ExpressionAttributeNames: { "#user_id": "user_id" },
    ExpressionAttributeValues: { ":user_id": user_id },
  });

  const res = await docClient.send(command);
  // map resource_id -> id (the old Lambda did this)
  return (res.Items || []).map((item) => ({
    ...item,
    id: item.resource_id,
  }));
};

const handler = async ({ user_id }, { rejectWithValue }) => {
  try {
    const { credentials } = await fetchAuthSession();
    const premises = await queryTable(credentials, { user_id });
    return premises;
  } catch (error) {
    console.error("services.customers.getCustomerPremises@handler", error);
    return rejectWithValue(error.message || "Failed to load premises");
  }
};

export default { handler };
